type ChainEnv = 'mainnet' | 'testnet';

export function useChainEnv(): ChainEnv {
  return 'testnet'; // TODO: figure out - process.env.NEXT_PUBLIC_L1_CHAIN_ID === '1' ? 'mainnet' : 'testnet';
}
